import $ from "jquery"
import "slick-carousel-latest"

if($('.js-work-slider').length){
    $('.js-work-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        arrow: true,
        dots: true,
        adaptiveHeight: true
    });
}